var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3330_646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5999 0.879883H4.39988C2.46388 0.879883 0.879883 2.46388 0.879883 4.39988V39.5999C0.879883 41.5359 2.46388 43.1199 4.39988 43.1199H39.5999C41.5359 43.1199 43.1199 41.5359 43.1199 39.5999V4.39988C43.1199 2.46388 41.5359 0.879883 39.5999 0.879883Z",
    fill: "#0E76A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7441 18.2161H23.3201V20.5041C23.9361 19.2721 25.6081 18.2161 27.8961 18.2161C32.7361 18.2161 33.2641 20.9441 33.2641 25.0801V33.4401H28.6881V25.7841C28.6881 24.0241 28.8641 22.0001 26.4001 22.0001C23.3201 22.0001 23.3201 23.8481 23.3201 25.7841V33.4401H18.7441V18.2161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1763 18.2161H15.7523V33.4401H11.1763V18.2161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4642 15.8401C14.9223 15.8401 16.1042 14.6581 16.1042 13.2001C16.1042 11.742 14.9223 10.5601 13.4642 10.5601C12.0062 10.5601 10.8242 11.742 10.8242 13.2001C10.8242 14.6581 12.0062 15.8401 13.4642 15.8401Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3330_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.45c6f3d9991107a8a9d6f57f0925cb9e.svg";
export { ForwardRef as ReactComponent };